import { Pagination, Table } from 'antd';
import React, { FC } from 'react';
import { TPreparedPollsPublicated, TPollsColumns } from 'shared/types/poll.types';
import SearchComponent from 'shared/components/search/news-faq';
import StringFormItem from 'shared/components/search/news-faq/stringFormItem/StringFormItem';
import { SearchKeysPoll } from 'shared/enums/poll';
import NumberFormItem from 'shared/components/search/news-faq/numberFormItem/NumberFormItem';
import style from './index.module.scss';

type TPollTableProps = {
  dataSource: TPreparedPollsPublicated[];
  columns: TPollsColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onSearch: (data: string, key: SearchKeysPoll) => void;
  onclickToRow?: (id: number) => void;
};

const PollTable: FC<TPollTableProps> = ({
  columns,
  currentPage,
  currentSize,
  dataSource,
  setCurrentPage,
  setCurrentSize,
  total,
  onclickToRow,
  onSearch,
}) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  return (
    <>
      <SearchComponent
        selectOptions={{
          [SearchKeysPoll.SEARCH_TITLE]: {
            name: SearchKeysPoll.SEARCH_TITLE,
            alias: 'Заголовок',
            node: StringFormItem({
              name: SearchKeysPoll.SEARCH_TITLE,
              placeholder: 'Введите заголовок',
              onSearch: data => {
                onSearch(data, SearchKeysPoll.SEARCH_TITLE);
              },
            }),
          },
          [SearchKeysPoll.SEARCH_NAME]: {
            name: SearchKeysPoll.SEARCH_NAME,
            alias: 'ФИО',
            node: StringFormItem({
              name: SearchKeysPoll.SEARCH_NAME,
              placeholder: 'Введите ФИО',
              onSearch: data => {
                onSearch(data, SearchKeysPoll.SEARCH_NAME);
              },
            }),
          },
          [SearchKeysPoll.SEARCH_ID]: {
            name: SearchKeysPoll.SEARCH_ID,
            alias: 'Номер',
            node: NumberFormItem({
              name: SearchKeysPoll.SEARCH_ID,
              placeholder: 'Введите номер опроса',
              onSearch: data => {
                onSearch(data, SearchKeysPoll.SEARCH_ID);
              },
            }),
          },
        }}
      />
      <Table
        scroll={{ x: true }}
        dataSource={dataSource}
        columns={columns}
        rowClassName="row"
        pagination={false}
        bordered
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              if (onclickToRow) {
                onclickToRow(+record.id);
              }
            },
          };
        }}
      />
      <div className={style.paginationWrap}>
        <Pagination
          defaultCurrent={1}
          showSizeChanger
          current={currentPage}
          total={total}
          pageSize={currentSize}
          onChange={(page, pageSize) => handlePagination(page, pageSize)}
        />
      </div>
    </>
  );
};

export default PollTable;
